module.exports = __webpack_public_path__ + "static/img/home5.1b7f5d0c.png";